import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../config/api";
import LoadingIndicator from "../Components/LoadingIndicator";

const UserReportEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [roles, setRoles] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    companyname: "",
    role: "",
    city: "",
    state: "",
    pincode: "",
    plan: "Free"
  });

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await axios.post(API_URL, {
          action: "getRole",
          page: 1,
          limit: 100
        });

        setRoles(res.data?.roles || []);
      } catch (err) {
        toast.error("Failed to load roles");
      }
    };

    fetchRoles();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      if (!id) return;

      setIsLoading(true);
      try {
        const res = await axios.post(API_URL, {
          action: "getUserById",
          id
        });

        const data = res.data?.data;

        setFormData({
          name: data?.name || "",
          phone: data?.phone || "",
          companyname: data?.companyname || "",
          role: data?.role || "",
          city: data?.city || "",
          state: data?.state || "",
          pincode: data?.pincode || "",
          plan: data?.plan || "Free"
        });
      } catch (err) {
        toast.error("Failed to load user");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("userid");

    if (!userId) {
      toast.error("Login required");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        action: "updateUser",
        id,
        ...formData,
        updatedBy: userId
      };

      const res = await axios.post(API_URL, payload);

      toast.success(res.data?.message || "User updated");
      navigate("/user-report");
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="employee-form">
      <div className="content-header">
        <div className="row align-items-center">
          <div className="col-sm-6">
            <h1>Edit User</h1>
            <p>Update user details</p>
          </div>
          <div className="col-sm-6 text-right">
            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
        </div>
      </div>

      <div className="card employee-content-card">
        <div className="card-body">
          {isLoading ? (
           <div className="employee-loading">
              <LoadingIndicator size={120} />
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className="col-md-6">
                  <label>Name *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label>Phone *</label>
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label>Company</label>
                  <input
                    type="text"
                    name="companyname"
                    className="form-control"
                    value={formData.companyname}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>Role *</label>
                  <select
                    name="role"
                    className="form-control"
                    value={formData.role}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Role</option>
                    {roles.map((r) => (
                      <option key={r._id} value={r.role}>
                        {r.role}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label>City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>State</label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    value={formData.state}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    className="form-control"
                    value={formData.pincode}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label>Plan</label>
                  <select
                    name="plan"
                    className="form-control"
                    value={formData.plan}
                    onChange={handleChange}
                  >
                    <option value="Free">Free</option>
                    <option value="Subscribed">Subscribed</option>
                  </select>
                </div>

              </div>

              <div className="form-actions mt-4 text-center">
                <button
                  type="submit"
                  className="btn btn-primary d-flex align-items-center justify-content-center mx-auto"
                  disabled={isSubmitting}
                  style={{ minWidth: "120px" }}
                >
                  {isSubmitting ? (
                    <LoadingIndicator size={22} className="inline-loader" />
                  ) : (
                    "Update"
                  )}
                </button>
              </div>

            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserReportEdit;